var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useHEREMap } from '@tenderd/track-web-utils';
import React, { useEffect, useRef, useState } from 'react';
import { GroupGeofenceMode, useGroupGeofencePageContext, } from '../../../GroupGeofencePage.context';
import './PolygonDraw.css';
import useCustomRef from './helpers/useCustomRef';
import { rectangleSvg } from './icons';
export var defaultDrawingStyles = {
    firstIcon: rectangleSvg('#185CF7').trim(),
    icon: rectangleSvg().trim(),
    polylineStylesOnDraw: {
        lineWidth: 3,
        strokeColor: '#185CF7',
        lineJoin: 'round',
    },
    polygonStylesOnDraw: {
        lineWidth: 0,
        fillColor: 'rgba(24, 92, 247, 0.2)',
    },
    movingPolylineStyles: {
        lineWidth: 3,
        strokeColor: '#185CF7',
        lineJoin: 'round',
        lineDash: [4],
        lineDashOffset: 1,
    },
    finalPolygonStyles: {
        lineWidth: 3,
        strokeColor: '#185CF7',
        lineJoin: 'round',
        fillColor: 'rgba(24, 92, 247, 0.2)',
    },
};
var defaultProps = {
    drawingStyles: {
        firstIcon: rectangleSvg('#185CF7').trim(),
        icon: rectangleSvg().trim(),
        polylineStylesOnDraw: {
            lineWidth: 3,
            strokeColor: '#185CF7',
            lineJoin: 'round',
        },
        polygonStylesOnDraw: {
            lineWidth: 0,
            fillColor: 'rgba(24, 92, 247, 0.2)',
        },
        movingPolylineStyles: {
            lineWidth: 3,
            strokeColor: '#185CF7',
            lineJoin: 'round',
            lineDash: [4],
            lineDashOffset: 1,
        },
        finalPolygonStyles: {
            lineWidth: 3,
            strokeColor: '#185CF7',
            lineJoin: 'round',
            fillColor: 'rgba(24, 92, 247, 0.2)',
        },
    },
    useShortcuts: true,
    shortcuts: {
        undo: {
            keyCode: 85,
            char: 'U',
        },
        merge: {
            keyCode: 77,
            char: 'M',
        },
        cancel: {
            keyCode: 27,
            char: 'ESC',
        },
    },
};
var PolygonDraw = function (_a) {
    var drawingStyles = _a.drawingStyles, color = _a.color, isResizable = _a.isResizable, onSuccess = _a.onSuccess, onPutCornerPoint = _a.onPutCornerPoint, useShortcuts = _a.useShortcuts, shortcuts = _a.shortcuts, onShortcutCallback = _a.onShortcutCallback;
    var H = window.H;
    var map = useHEREMap().map;
    var context = useGroupGeofencePageContext();
    var _b = __read(useState([]), 2), polygonObjects = _b[0], setPolygonObjects = _b[1];
    var _c = __read(useState(false), 2), isActionsOpen = _c[0], setIsActionsOpen = _c[1];
    var verticeGroup = useRef(new H.map.Group()); // Vertices of polygon object, contains markers
    var drawnPolystrip = useRef(new H.geo.LineString()); // Every time a vertice added this will be updated and final polygon will be drawn with it.
    var movingPolystrip = useRef(new H.geo.LineString()); // First point will be last clicked point, second point will be updated on mouse move
    var movingPolyline = useRef(); // On mouse move, a polyline that follow mouse move will created and updated smoothly
    var polylineOnDraw = useRef();
    var polygonOnDraw = useRef();
    var tooltipRef = useCustomRef().ref;
    var _d = __read(useState(0), 2), pointCount = _d[0], setPointCount = _d[1];
    useEffect(function () {
        if (!map)
            return;
        if (context.mode === GroupGeofenceMode.Geofence) {
            map.getElement().style.cursor = 'pointer';
            setIsActionsOpen(true);
        }
        else {
            map.getElement().style.cursor = 'grab';
            var polygonObjects_1 = map.getObjects().filter(function (obj) {
                var _a;
                return (_a = obj.getData()) === null || _a === void 0 ? void 0 : _a.customPolygon;
            });
            polygonObjects_1.length && map.removeObjects(polygonObjects_1);
        }
    }, [context.mode, map]);
    useEffect(function () {
        if (map && isActionsOpen) {
            map.addEventListener('pointerdown', handleClickOnMap);
            map.addEventListener('pointermove', handleMoveOnMap);
            document.addEventListener('keydown', handleKeydown);
            window.addEventListener('mousemove', handleTooltipPosition);
            return function () {
                map.removeEventListener('pointermove', handleMoveOnMap);
                document.removeEventListener('keydown', handleKeydown);
                map.removeEventListener('pointerdown', handleClickOnMap);
                window.removeEventListener('mousemove', handleTooltipPosition);
            };
        }
    }, [map, isActionsOpen]);
    var currentPointCount = function () {
        return drawnPolystrip.current.getPointCount();
    };
    var handleClickOnMap = function (event) {
        // On drawing phase, whenever user clicks on map, a marker created...
        // ...and these markers will be vertices of final polygon.
        // Also they will be used to handle edit functionality.
        if (isActionsOpen) {
            setPointCount(function (state) { return state + 1; });
            // get clicked point coords, create a marker, add to verticeGroup.
            var screenPoint = map.screenToGeo(event.currentPointer.viewportX, event.currentPointer.viewportY);
            drawnPolystrip.current.pushPoint(screenPoint);
            var marker = new H.map.Marker(screenPoint, {
                icon: new H.map.Icon(drawingStyles.icon),
                data: {},
            });
            verticeGroup.current.addObject(marker);
            // reset moving objects
            if (movingPolystrip.current.getPointCount() === 2) {
                movingPolystrip.current.removePoint(0);
                movingPolystrip.current.removePoint(1);
            }
            // add clicked point to moving strip
            movingPolystrip.current.insertPoint(0, screenPoint);
            if (currentPointCount() >= 3) {
                // With 3 point, a polygon can shown on map
                if (polygonOnDraw.current) {
                    var geoPolygon = new H.geo.Polygon(drawnPolystrip.current);
                    polygonOnDraw.current.setGeometry(geoPolygon);
                }
                else {
                    polygonOnDraw.current = new H.map.Polygon(drawnPolystrip.current, {
                        style: __assign({}, drawingStyles.polygonStylesOnDraw),
                        data: {},
                    });
                    map.addObject(polygonOnDraw.current);
                }
            }
            if (currentPointCount() >= 2) {
                // With second point, a polyline will be drawn
                if (polylineOnDraw.current) {
                    polylineOnDraw.current.setGeometry(drawnPolystrip.current);
                }
                else {
                    polylineOnDraw.current = new H.map.Polyline(drawnPolystrip.current, {
                        style: __assign(__assign({}, drawingStyles.polylineStylesOnDraw), (color && {
                            strokeColor: color,
                        })),
                        data: {},
                    });
                    map.addObject(polylineOnDraw.current);
                }
            }
            else if (currentPointCount() === 1) {
                // On first point, set first point icon
                map.addObject(verticeGroup.current);
                marker.setIcon(new H.map.Icon(drawingStyles.firstIcon || drawingStyles.icon));
                marker.addEventListener('tap', function () { return handleComplete(false); });
            }
            onPutCornerPoint &&
                onPutCornerPoint({ currentPointCount: currentPointCount() });
        }
    };
    var moveSmooth = function (oldPoint, newPoint, latIncrease, lngIncrease, counter) {
        if (movingPolyline.current) {
            movingPolystrip.current.removePoint(1);
            movingPolystrip.current.pushPoint({
                lat: oldPoint.lat + latIncrease,
                lng: oldPoint.lng + lngIncrease,
            });
            movingPolyline.current.setGeometry(movingPolystrip.current);
            if (counter !== 5) {
                moveSmooth({
                    lat: oldPoint.lat + latIncrease,
                    lng: oldPoint.lng + lngIncrease,
                }, newPoint, latIncrease, lngIncrease, counter + 1);
            }
        }
    };
    var handleMoveOnMap = function (event) {
        if (!(isActionsOpen && movingPolystrip.current.getPointCount() > 0))
            return;
        // get pointer position as H.Point
        var newPoint = map.screenToGeo(event.currentPointer.viewportX, event.currentPointer.viewportY);
        if (movingPolyline.current) {
            // if polyline created, update with new point
            var oldPoint_1 = movingPolystrip.current.extractPoint(1);
            var latIncrease_1 = -1 * ((oldPoint_1.lat - newPoint.lat) / 5);
            var lngIncrease_1 = -1 * ((oldPoint_1.lng - newPoint.lng) / 5);
            requestAnimationFrame(function () {
                return moveSmooth(oldPoint_1, newPoint, latIncrease_1, lngIncrease_1, 1);
            });
        }
        else {
            // create polyline
            movingPolystrip.current.pushPoint(newPoint);
            movingPolyline.current = new H.map.Polyline(movingPolystrip.current, {
                style: __assign(__assign({}, drawingStyles.movingPolylineStyles), (color && { strokeColor: color })),
                volatility: true,
                data: {},
            });
            map.addObject(movingPolyline.current);
        }
    };
    var handleComplete = function (fromShortcut) {
        if (fromShortcut === void 0) { fromShortcut = false; }
        if (currentPointCount() >= 3) {
            var mainGroup_1 = isResizable
                ? console.log('resizable')
                : addStandartPolygon(drawnPolystrip.current, fromShortcut);
            handleEscape();
            setPolygonObjects(function (state) { return __spreadArray(__spreadArray([], __read(state), false), [mainGroup_1], false); });
            var coordinates = getCoordinates(mainGroup_1.getPolygon());
            onSuccess && onSuccess(coordinates);
        }
    };
    var addStandartPolygon = function (polystrip, fromShortcut) {
        if (fromShortcut === void 0) { fromShortcut = false; }
        if (!fromShortcut) {
            polystrip.removePoint(0);
        }
        var finalPolygon = new H.map.Polygon(polystrip, {
            style: __assign(__assign({}, drawingStyles.finalPolygonStyles), (color && {
                strokeColor: color,
            })),
            data: {
                customPolygon: true,
            },
        });
        var mainGroup = new H.map.Group({
            volatility: true,
            objects: [finalPolygon],
            data: {
                customPolygon: true,
            },
        });
        mainGroup.getPolygon = function () { return finalPolygon; };
        map.addObject(mainGroup);
        return mainGroup;
    };
    var handleTooltipPosition = function (e) {
        var x = e.clientX, y = e.clientY;
        if (tooltipRef.current) {
            tooltipRef.current.style.top = y - 5 + 'px';
            tooltipRef.current.style.left = x + 20 + 'px';
        }
    };
    var handleKeydown = function (e) {
        // U: 85 C: 67 M: 77 ESC: 27
        if (useShortcuts && shortcuts) {
            if (e.keyCode === shortcuts.undo.keyCode) {
                // removeLastPoint
                onShortcutCallback &&
                    onShortcutCallback({
                        keyCode: shortcuts.undo.keyCode,
                        char: shortcuts.undo.char,
                    });
                handleUndo();
            }
            else if (e.keyCode === shortcuts.merge.keyCode) {
                onShortcutCallback &&
                    onShortcutCallback({
                        keyCode: shortcuts.merge.keyCode,
                        char: shortcuts.merge.char,
                    });
                handleComplete(true);
            }
            else if (e.keyCode === shortcuts.cancel.keyCode) {
                onShortcutCallback &&
                    onShortcutCallback({
                        keyCode: shortcuts.cancel.keyCode,
                        char: shortcuts.cancel.char,
                    });
                context.setMode(undefined);
                handleEscape();
            }
        }
    };
    var handleEscape = function () {
        var _a;
        setIsActionsOpen(false);
        setPointCount(0);
        if (((_a = verticeGroup.current) === null || _a === void 0 ? void 0 : _a.getObjects().length) === 0)
            return; // nothing to delete
        polygonOnDraw.current && map.removeObject(polygonOnDraw.current);
        polylineOnDraw.current && map.removeObject(polylineOnDraw.current);
        movingPolyline.current && map.removeObject(movingPolyline.current);
        verticeGroup.current && map.removeObject(verticeGroup.current);
        verticeGroup.current.removeObjects(verticeGroup.current.getObjects());
        polygonOnDraw.current = null;
        polylineOnDraw.current = null;
        drawnPolystrip.current = new H.geo.LineString();
        movingPolystrip.current = new H.geo.LineString();
        movingPolyline.current = null;
    };
    var handleUndo = function () {
        if (currentPointCount() > 2) {
            setPointCount(function (state) { return state - 1; });
            drawnPolystrip.current.removePoint(drawnPolystrip.current.getPointCount() - 1);
            var a = drawnPolystrip.current.extractPoint(drawnPolystrip.current.getPointCount() - 1);
            var geoPolygon = new H.geo.Polygon(drawnPolystrip.current);
            polygonOnDraw.current.setGeometry(geoPolygon);
            polylineOnDraw.current.setGeometry(drawnPolystrip.current);
            movingPolystrip.current.insertPoint(0, a);
            movingPolystrip.current.removePoint(1);
            movingPolyline.current.setGeometry(movingPolystrip.current);
            verticeGroup.current.removeObject(verticeGroup.current.getObjects()[verticeGroup.current.getObjects().length - 1]);
        }
    };
    return (React.createElement("div", null, isActionsOpen && (React.createElement("div", { className: "drawing-action-box" },
        React.createElement("div", { className: "sub-action ".concat(isActionsOpen ? 'open' : '') },
            React.createElement("div", { onClick: function () { return handleComplete(true); }, className: pointCount >= 3 ? '' : 'disabled' },
                "Close Shape",
                ' ',
                useShortcuts && (React.createElement("span", { className: "shortcut" },
                    "(", shortcuts === null || shortcuts === void 0 ? void 0 :
                    shortcuts.merge.char,
                    ")"))),
            React.createElement("div", { className: "divider" }),
            React.createElement("div", { onClick: handleUndo, className: pointCount > 2 ? '' : 'disabled' },
                "Delete Last Point",
                ' ',
                useShortcuts && (React.createElement("span", { className: "shortcut" },
                    "(", shortcuts === null || shortcuts === void 0 ? void 0 :
                    shortcuts.undo.char,
                    ")"))),
            React.createElement("div", { className: "divider" }),
            React.createElement("div", { onClick: function () {
                    handleEscape();
                    context.setMode(undefined);
                } },
                "Cancel",
                ' ',
                useShortcuts && (React.createElement("span", { className: "shortcut" },
                    "(", shortcuts === null || shortcuts === void 0 ? void 0 :
                    shortcuts.cancel.char,
                    ")"))))))));
};
PolygonDraw.defaultProps = defaultProps;
export default PolygonDraw;
export var getCoordinates = function (polygon) {
    return polygon
        .getGeometry()
        .toGeoJSON()
        .coordinates[0].reduce(function (acc, curr) {
        acc.push([curr[1], curr[0]]);
        return acc;
    }, []);
};
